
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-idle-timeout-modal',
  standalone: true,
  imports: [],
  template: `
    <div class="modal-overlay" >
      <div class="modal-container" >
        <!-- Icon -->
        <div class="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>

        <!-- Content -->
        <div class="modal-content">
          <h2 class="modal-title">Sesión Expirada</h2>
          <p class="modal-message">
            Tu sesión ha expirado por inactividad.
          </p>
          <p class="modal-submessage">
            Por seguridad, debes iniciar sesión nuevamente para continuar.
          </p>
        </div>

        <!-- Actions -->
        <div class="modal-actions">
          <button class="btn-primary" (click)="onLoginClick()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(26, 26, 46, 0.8);
      backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      animation: fadeIn 0.3s ease;
      padding: 1rem;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .modal-container {
      background: white;
      border-radius: 20px;
      padding: 2.5rem;
      max-width: 440px;
      width: 100%;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      animation: slideUp 0.3s ease;
      border: 1px solid rgba(102, 126, 234, 0.1);
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .modal-icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 1.5rem;
      background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    .modal-icon::before {
      content: '';
      position: absolute;
      inset: -4px;
      border-radius: 50%;
      border: 2px solid rgba(239, 68, 68, 0.2);
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.5;
        transform: scale(1.1);
      }
    }

    .modal-icon svg {
      width: 40px;
      height: 40px;
      color: #ef4444;
      stroke-width: 2.5;
    }

    .modal-content {
      text-align: center;
      margin-bottom: 2rem;
    }

    .modal-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1a1a2e;
      margin: 0 0 1rem 0;
    }

    .modal-message {
      font-size: 1rem;
      color: #374151;
      margin: 0 0 0.5rem 0;
      line-height: 1.5;
    }

    .modal-submessage {
      font-size: 0.875rem;
      color: #6b7280;
      margin: 0;
      line-height: 1.5;
    }

    .modal-actions {
      display: flex;
      justify-content: center;
    }

    .btn-primary {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.875rem 2rem;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      border-radius: 12px;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    .btn-primary svg {
      width: 20px;
      height: 20px;
      stroke-width: 2.5;
    }

    .btn-primary:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:active {
      transform: translateY(0);
    }

    @media (max-width: 480px) {
      .modal-container {
        padding: 2rem 1.5rem;
      }

      .modal-title {
        font-size: 1.25rem;
      }

      .modal-icon {
        width: 64px;
        height: 64px;
      }

      .modal-icon svg {
        width: 32px;
        height: 32px;
      }

      .btn-primary {
        width: 100%;
        justify-content: center;
      }
    }
  `]
})
export class IdleTimeoutModalComponent {
  // private authService = inject(AuthService);
  // private router = inject(Router);

  /** Emite cuando el usuario quiere iniciar sesión nuevamente */
  @Output() loginRequested = new EventEmitter<void>();

  onLoginClick(): void {
    // Emitir evento para que el padre oculte el modal de inmediato (sincrónicamente)
    // antes de llamar logout(), evitando que el modal permanezca visible
    // durante toda la navegación hacia /login
    this.loginRequested.emit();
  }

  // onBackdropClick(event: MouseEvent): void {
  //   // Permitir cerrar haciendo clic fuera del modal (opcional)
  //   // Para este caso, mejor no permitirlo ya que debe iniciar sesión
  // }
}
